/*
  Cleaned Custom JS for iB-iP
  Purpose: Basic site interactions (Menu, Login, Cart)
  Updated: 2026-01-29
*/

(function($) {
  "use strict";

  $(function() {
    // 1. 移动端浏览器菜单跳转
    $("select#mobile-menu").on('change', function() {
      window.location = $(this).find("option:selected").val();
    });

    // 2. 登录/找回密码框切换
    $("#forgot-password-box").on('click', function() {
      $("#customer-login").hide();
      $("#recover-password").show();
    });

    $("#login-box-link").on('click', function() {
      $("#customer-login").show();
      $("#recover-password").hide();
    });

    // 3. 侧边栏购物车 (Sidr)
    if ($.isFunction($.fn.sidr)) {
      $('.slide-menu').sidr({
        name: 'sidr',
        side: 'right'
      });
      $('#sidr').show();
    }

    // 4. 移动端菜单 (mmenu)
    if ($.isFunction($.fn.mmenu)) {
      $("#menu").mmenu({
        navbar: {
          title: ""
        }
      });
    }

    // 5. 网格高度对齐 (MatchHeight)
    if ($.isFunction($.fn.matchHeight)) {
      $('.homepage-collection-grid-inner .grid-image').matchHeight();
    }

    // 6. 弹出层 (FancyBox)
    if ($.isFunction($.fn.fancybox)) {
      $(".fancybox").fancybox();
      $(".fancybox-instagram").fancybox({
        padding: 0
      });
    }
  });

})(jQuery);
